// store/authSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
import { API_BASE_URL } from "../../config";

const initialState = {
  isAuthenticated: false,
  user: null,
  token: null,
  loading: true, // пока не проверили
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true;
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.loading = false;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.user = null;
      state.loading = false;
    },
    finishLoading: (state) => {
      state.loading = false;
    },
  },
});

export const { login, logout, finishLoading } = authSlice.actions;
export default authSlice.reducer;

export const checkToken = () => async (dispatch) => {
  const accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");

  if (!refreshToken) {
    dispatch(finishLoading());
    return;
  }

  if (!accessToken) {
    // пробуем обновить токен
    return dispatch(tryRefreshToken());
  }

  try {
    const decoded = jwtDecode(accessToken);
    const now = Date.now() / 1000;

    if (decoded.exp && decoded.exp < now) {
      // access истёк → пробуем обновить
      return dispatch(tryRefreshToken());
    }

    // access жив
    dispatch(
      login({
        token: accessToken,
        user: { id: decoded.user_id || decoded.guid },
      })
    );
  } catch (e) {
    // токен повреждён → пробуем refresh
    dispatch(tryRefreshToken());
  }
};

// thunk для обновления токена
const tryRefreshToken = () => async (dispatch) => {
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) {
    dispatch(logout());
    return;
  }

  try {
    const res = await fetch(API_BASE_URL + "/api/app/auth/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken }),
    });

    const data = await res.json();

    if (!data.accessToken) {
      dispatch(logout());
      return;
    }

    // сохраняем новые токены
    localStorage.setItem("accessToken", data.accessToken);
    localStorage.setItem("refreshToken", data.refreshToken);

    const decoded = jwtDecode(data.accessToken);

    dispatch(
      login({
        token: data.accessToken,
        user: decoded,
      })
    );
  } catch (e) {
    dispatch(logout());
  }
};


// export const checkToken = () => (dispatch) => {
//   const token = localStorage.getItem("accessToken");
//   if (!token) {
//     dispatch(finishLoading());
//     return;
//   }

//   try {
//     const decoded = jwtDecode(token ?? ""); // { exp, iat, ... }
//     const now = Date.now() / 1000;

//     if (decoded.exp && decoded.exp < now) {
//       // токен истёк
//       localStorage.removeItem("accessToken");
//       dispatch(logout());
//     } else {
//       // токен ок — можно дернуть API для получения пользователя
//       dispatch(
//         login({
//           token,
//           user: { id: decoded.guid }, // либо грузим с сервера
//         })
//       );
//     }
//   } catch (e) {
//     localStorage.removeItem("accessToken");
//     dispatch(logout());
//   }
// };